/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AutocompleteAddressResponseBaseResponse as ModelsCustomerAutocompleteAddressResponseBaseResponse } from '../../models/Models/Customer/autocomplete-address-response-base-response';

export interface V4PublicApplicationApplicationIdGetAddressAutocompleteGet$Plain$Params {
  query?: string;
  applicationId: string;
}

export function v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Plain(http: HttpClient, rootUrl: string, params: V4PublicApplicationApplicationIdGetAddressAutocompleteGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerAutocompleteAddressResponseBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Plain.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.path('applicationId', params.applicationId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerAutocompleteAddressResponseBaseResponse>;
    })
  );
}

v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Plain.PATH = '/v4/public/application/{applicationId}/getAddressAutocomplete';
